import { dark } from "@clerk/themes";
import type { Appearance } from "@clerk/types";

/** Clerk `<SignIn />` / `<SignUp />` on the public admin landing (dark shell, readable OAuth labels). */
export const adminPublicAuthAppearance: Appearance = {
  baseTheme: dark,
  variables: {
    colorPrimary: "#22d3bb",
    /** Text on primary CTA (teal) — keep dark for contrast */
    colorPrimaryForeground: "#04100e",
    colorBackground: "#131820",
    /** Clerk v5+ — drives default text; fixes OAuth labels vs deprecated colorText */
    colorForeground: "#e6e9ef",
    colorMutedForeground: "#8b95a8",
    colorInput: "#1a2130",
    colorInputForeground: "#e6e9ef",
    /** Neutral scale — avoid auto-generated dark text on dark OAuth buttons */
    colorNeutral: "#5c6575",
    colorDanger: "#f87171",
    borderRadius: "10px",
  },
  elements: {
    rootBox: {
      width: "100%",
    },
    card: {
      backgroundColor: "#1a2130",
      border: "1px solid #2a3344",
      boxShadow: "none",
    },
    socialButtonsBlockButton: {
      color: "#e6e9ef",
      borderColor: "#3d4a5e",
      backgroundColor: "#131820",
    },
    socialButtonsBlockButtonText: {
      color: "#e6e9ef",
    },
  },
};
